module.exports = __webpack_public_path__ + "static/media/david-frontend.a5d9212c.png";